// extracted by mini-css-extract-plugin
export default {"dialog":"UserAuthDialog_dialog__YJHGu","dialogField":"UserAuthDialog_dialogField__H05NL","dialogButton":"UserAuthDialog_dialogButton__THmYQ"};